import Vue from 'vue'
import VueRouter from 'vue-router'
//import swal from 'sweetalert2'

import Inicio from '@/views/publica/Inicio'
import Nosotros from '@/views/publica/Nosotros'
import QuieroSerCliente from '@/views/publica/QuieroSerCliente'
import PreguntasFrecuentes from '@/views/publica/PreguntasFrecuentes'
import Contacto from '@/views/publica/Contacto'
import AvisoPrivacidad from '@/views/publica/AvisoPrivacidad'
import CartaPorte from '@/views/publica/CartaPorte'
import CartaPorteId from '@/views/publica/CartaPorteId'
import AuthComponent from '@/views/Auth'
import BolsaTrabajo from '@/views/publica/BolsaTrabajo'

import RecuperarPassword from '@/views/publica/RecuperarPassword'
import LayoutClientes from '@/views/clientes/Layout'

import AvisoPrivacidadComponent from '@/components/publica/AvisoPrivacidad'

import InicioClientes from "@/views/clientes/Inicio";
import MiListaPedido from "@/views/clientes/captura-pedidos/MiListaPedido";
//import CatalogoGeneral from "@/views/clientes/captura-pedidos/CatalogoGeneral";
import BusquedaGeneral from '@/views/clientes/captura-pedidos/BusquedaGeneral'
import BusquedaAvanzada from '@/views/clientes/captura-pedidos/BusquedaAvanzada'
import Nuevo from "@/views/clientes/captura-pedidos/Nuevos";
import Ofertas from "@/views/clientes/captura-pedidos/Ofertas";
import Remates from "@/views/clientes/captura-pedidos/Remates";
import BuenFin from "@/views/clientes/captura-pedidos/BuenFin";
import CambioPrecio from "@/views/clientes/captura-pedidos/CambioPrecio";
import EstatusDePedido from "@/views/clientes/EstatusPedidoNew";
import Adeudos from "@/views/clientes/Adeudos";
import Facturas from "@/views/clientes/Facturas";
import Carrito from "@/views/clientes/Carrito";

import Pagar from "@/views/clientes/Pagar";
import ReferenciarPagosReimprimirRecibo from "@/views/clientes/ReferenciarPagosReimprimirRecibo"
import ReferenciarPagos from "@/views/clientes/ReferenciarPagos";
import Estadisticas from "@/views/clientes/Estadisticas";
import Ayuda from "@/views/clientes/Ayuda";
import DetalleProducto from "@/views/clientes/DetalleProducto"
import Configuracion from "@/views/clientes/configuracion-cuenta/Configuracion";
import CambiaPassword from "@/views/clientes/configuracion-cuenta/ConfiguracionCambioPassword";

import CatalogoPruebas from '@/views/publica/CatalogoPruebas'

import Herramientas from "@/views/clientes/Herramientas"

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		component: Inicio,
		meta: { isPublic: true }
	},
	{
		path: '/nosotros',
		component: Nosotros,
		meta: { isPublic: true }
	},
	{
		path: '/quiero-ser-cliente',
		component: QuieroSerCliente,
		meta: { isPublic: true }
	},
	{
		path: '/preguntas-frecuentes',
		component: PreguntasFrecuentes,
		meta: {
			reload: true,
			isPublic: true
		}
	},
	{
		path: '/contacto',
		component: Contacto,
		meta: { isPublic: true }
	},
	{
		path: '/portal-proveedores',
		beforeEnter() {                    
			window.open("https://www.difarmer.com/proveedores/", '_blank');
		}
	},
	{
		path: '/aviso-privacidad',
		component: AvisoPrivacidad,
		meta: { isPublic: true }
	},
	{
		path: '/recuperar-password/:ref',
		component: RecuperarPassword,
		name: 'RecuperarPassword',
		meta: { isPublic: true }
	},
	{
		path: '/bolsa-trabajo',
		component: BolsaTrabajo,
		meta: { isPublic: true }
	},
	{		
		path: '/clientes',
		component: LayoutClientes,
		children: 
			[
				{ name:"inicio", path: "", component: InicioClientes },
				{ name:'mi-lista-de-pedido', path: "captura-pedidos/mi-lista-de-pedido", component: MiListaPedido },
				{ path: 'captura-pedidos/busqueda-general', component: BusquedaGeneral, name: 'busqueda-general' },
				{ path: 'captura-pedidos/busqueda-avanzada', component: BusquedaAvanzada, name: 'busqueda-avanzada' },
				//{ name: "catalogo-general", path: "captura-pedidos/catalogo-general/buscar/:buscar/pagina/:pagina/:orden/:codClasificacion/:codFormaFarmaceutica/:codFormula/:tipoFormula/:contenidoVenta/:busquedaAvanzada", component: CatalogoGeneral },				
				{ path: "captura-pedidos/nuevos", component: Nuevo },
				{ path: "captura-pedidos/remates", component: Remates },
				{ path: "captura-pedidos/ofertas", component: Ofertas },
				{ path: "captura-pedidos/buen-fin", component: BuenFin },
				{ path: "captura-pedidos/cambio-de-precio", component: CambioPrecio },
				{ path: "estatus-de-pedido", component: EstatusDePedido },
				{ path: "adeudos", component: Adeudos },
				{ path: "facturas", component: Facturas },
				{ path: "carrito", component: Carrito },
				{ path: "pagar", component: Pagar },
				{ path: "referenciarpagos", component: ReferenciarPagos },
				{ path: "referenciarpagosreimprimir", component: ReferenciarPagosReimprimirRecibo },
				{ path: "estadisticas", component: Estadisticas },
				{ path: "ayuda/:activo", component: Ayuda },
				{ path: "detalle-producto/:codArticulo", component: DetalleProducto },
				{ path: "configuracion", component: Configuracion },
				{ path: "configuracion/cambio-password", component: CambiaPassword },
				{ path: 'aviso-privacidad', component: AvisoPrivacidadComponent },
				{ path: 'herramientas', component: Herramientas },
			]
	},
	{
		path: '/carta-porte/:json',
		component: CartaPorte,
		meta: { isPublic: true }
	},
	{
		path: '/carta-porte-id/:json',
		component: CartaPorteId,
		meta: { isPublic: true }
	},
	{
		path: '/auth',
		component: AuthComponent,
		meta: { isPublic: true }
	},
	{
		path: '/catalogo',
		component: CatalogoPruebas,
		meta: { isPublic: true }
	},
]

const router = new VueRouter({
	//mode: 'history',
	base: process.env.BASE_URL,
	routes,	
	scrollBehavior(to){
		if (to.hash) {
			return {
				selector: to.hash
			}
		}
	}
})

const isAuthenticated = () => {
	let token = undefined;
	//if(window.localStorage.user){
	if(window.localStorage.tokenDifarmer){
		let lsToken = JSON.parse(window.localStorage.tokenDifarmer);
		token = lsToken.token;
		//var date = new Date(window.localStorage.expiresAt);
		var date = new Date(lsToken.expiresAt);

		if(date < Date.now()){
			//window.localStorage.removeItem('user')
			//window.localStorage.removeItem('token')
			//window.localStorage.removeItem('expiresAt')
			//window.localStorage.removeItem('refreshToken')
			window.localStorage.removeItem('tokenDifarmer')

			// swal.fire({
			// text: 'La sesión ha caducado, por favor vuelva a autenticarse para continuar',
			// icon: 'warning'
			// })
		}
	}

	//return window.localStorage.token
	return token != undefined;
}

router.beforeEach((to, from, next) => {
	if(to.path.includes("/auth")){
		return next()
	}

	// let authenticated = isAuthenticated()
	
	// console.log("authenticated => ", authenticated)
	// console.log("to => ", to)

	if (!isAuthenticated() && to.path.includes('/clientes/')) {        
        if (!localStorage.getItem("RouteTo")) {
            localStorage.setItem("RouteTo", to.path)			
			localStorage.setItem("RouteToQuery", JSON.stringify(to.query))
        }
		
		return next({path: '/'})
    }

	if(!to.meta.isPublic && !isAuthenticated()){
		return next({path: '/'})
	}

	if(!to.path.includes('/clientes/') && isAuthenticated()){
		return next({ path: '/clientes/' })
	}

	if (isAuthenticated() && localStorage.getItem("RouteTo")) {
        let path = localStorage.getItem("RouteTo")
		let query = JSON.parse(localStorage.getItem("RouteToQuery"))

        localStorage.removeItem("RouteTo")
		localStorage.removeItem("RouteToQuery")

        return next({ path: path, query: query })
    }

	return next()
})


export default router
